import { classnames } from '@aibees/shared/utils';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import variablePie from 'highcharts/modules/variable-pie';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { VariablePieChartProps as Props } from './types';

variablePie(Highcharts);

export const VariablePieChart = memo(({ className, options }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('VariablePieChart', className)}
      sx={SX.root}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Styled.Wrapper>
  );
});

VariablePieChart.displayName = 'VariablePieChart';
